<div id="cpqInputErrorContainer" class="fiori3-input-group input-group" [class.full-width]='dynamicWidth' [class.info-shown]="infoMessage">
  <div class="flex align-left">
    @if (label && !hideLabel) {
      <label>
        {{label.value ? label.value : (label.key | translate)}}
      </label>
    }
    @if (infoMessage) {
      <cpq-info class="cpq-info-icon" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
    }
  </div>
  <input [attr.tabindex]='tabindex' id="{{ id ? id : name }}" [disabled]='disabled' name="{{name}}" class="form-control" type="{{type}}" [class.ng-valid]="valid" [class.ng-invalid]="!valid"
    [(ngModel)]="value" placeholder="{{label?.placeholder ? (label.placeholder | translate) : ''}}" (blur)="touched($event)" (keydown)="onEnter($event)" (focusout)='onFocusOut.emit($event)'/>
    <show-errors [errorHintPosition]="errorHintPosition" [control]='control'></show-errors>
    @if (config) {
      <span class="blue-link formula-builder">
        <button type="button" class="btn btn-link button-link" [attr.id]="name ? name + '_FormulaBuilder' : 'formulaBuilder'" (click)="openFormulaBuilder(value)" [disabled]="disabled">
          <span class="sap-icon">&#xe19f;</span>
          @if (!config.hideLabel) {
            {{'FormulaBuilder.Title' | translate}}
          }
        </button>
      </span>
    }
  </div>
